export const isValidArray = (
  array: unknown,
  minLength = 0,
): array is unknown[] => Array.isArray(array) && array.length > minLength

export const hasEmptyElements = (array: unknown[]): boolean =>
  Array.isArray(array) && array.filter((item) => !!item).length === 0

export const isEmptyArray = (array: unknown): array is [] =>
  Array.isArray(array) && array.length === 0

/**
 * Filters out empty elements from an array
 * @param items - The array to filter
 * @param isNumberTypeExcluded - Whether to exclude number type from filtering (numbers are always kept)
 * @returns An array containing the elements that passed the test if it is valid, otherwise returns the original array
 */
export const filterEmptyElementInArray = <T>(
  items: T[] | null | undefined = [],
  isNumberTypeExcluded = true,
): T[] | null | undefined => {
  if (isValidArray(items)) {
    let filterCallback = (item: T): boolean => !!item

    if (isNumberTypeExcluded) {
      filterCallback = (item: T): boolean => {
        if (typeof item === 'number') {
          return true
        }
        if (typeof item === 'string' && item.trim() === '') {
          return false
        }
        return !!item
      }
    }

    return items.filter(filterCallback)
  }

  return items
}

export const mergeIntoStringWithSeparator =
  (separator = ' ') => (...elements: unknown[]): string => {
    if (isValidArray(elements)) {
      const filteredArray = filterEmptyElementInArray(elements.flat())
      return filteredArray.join(separator)
    }
    return ''
  }
